import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { useKioskContext } from "../context/KioskContext";

// Logo paths
const LOGOS = {
  foodpanda: "/assets/logos/foodpanda.png",
  grabfood: "/assets/logos/grabfood.png",
};

const normalize = (str) => str.toLowerCase().replace(/\s+/g, "");

const DeliverySelect = ({ onSelect, onBack, posId }) => {
  const { translate, setSelectedDelivery } = useKioskContext();
  const [deliveries, setDeliveries] = useState([]);

  useEffect(() => {
    const fetchDeliveries = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/v1/api/menu/fetch-public-deliveries?posId=${posId}`
        );
        const enabled = res.data?.deliveries?.filter((d) => d.toggle) || [];
        setDeliveries(enabled);
      } catch (err) {
        console.error("Error fetching delivery options:", err);
      }
    };

    fetchDeliveries();
  }, [posId]);

  const handleSelect = (delivery) => {
    setSelectedDelivery(delivery.deliveryName);
    onSelect(delivery.deliveryName);
  };

  return (
    <>
      <Box sx={{ position: "fixed", top: 20, left: 20, zIndex: 10 }}>
        <IconButton onClick={onBack}>
          <ArrowBackIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 3,
        }}
      >
        <Typography variant="h4" gutterBottom>
          {translate("Select Delivery Type", {
            en: "Select Delivery Type",
            zh: "选择配送类型",
            th: "เลือกประเภทการจัดส่ง",
            tl: "Pumili ng Uri ng Delivery",
          })}
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {deliveries.map((delivery) => {
            const nameKey = normalize(delivery.deliveryName);
            const logo = LOGOS[nameKey];

            return (
              <Grid item xs={12} sm={6} md={4} key={delivery.deliveryName}>
                <Paper
                  elevation={3}
                  onClick={() => handleSelect(delivery)}
                  sx={{
                    p: 3,
                    minHeight: 115,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    cursor: "pointer",
                    borderRadius: 4,
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: 8,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                    }}
                  >
                    {logo && (
                      <img
                        src={logo}
                        alt={delivery.deliveryName}
                        style={{ height: 60, width: 60, objectFit: "contain" }}
                      />
                    )}
                    <Typography variant="h5" textAlign="center">
                      {delivery.deliveryName}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export default DeliverySelect;
